import { Link } from "react-router-dom";
import { events } from "@/mocks/content";

export default function FocusSection() {
  const [main, second, third] = events;
  if (!main) return null;

  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20" aria-labelledby="focus-title">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            Today&apos;s Focus
          </p>
          <h2
            id="focus-title"
            className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl"
          >
            今日焦点事件
          </h2>
        </div>
        <p className="max-w-md text-sm leading-relaxed text-foreground-600">
          从讨论量快速上升的话题里，挑出最值得先了解脉络的几条，帮你抓住今天的重点。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        <article className="group relative overflow-hidden rounded-lg border border-background-200/80 lg:col-span-7">
          <Link to={`/events/${main.slug}`} className="relative block h-72 w-full md:h-[420px]" aria-label={main.title}>
            <img
              src={main.cover}
              alt={`${main.title} 事件配图`}
              title={`${main.title} - 每日吃瓜焦点事件`}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-flashlight-fill"></i>
                焦点
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
                {main.title}
              </h3>
              <p className="line-clamp-2 mt-3 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
                {main.summary}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-background-200">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-primary-300"></i>
                  热度 {main.heat.toFixed(1)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  阅读约 {main.readTime}
                </span>
                <span className="rounded-full bg-background-50/15 px-2.5 py-0.5">{main.category}</span>
              </div>
            </div>
          </Link>
        </article>

        <div className="flex flex-col gap-6 lg:col-span-5">
          {[second, third].map((item) =>
            item ? (
              <article
                key={item.slug}
                className="group flex flex-1 gap-4 overflow-hidden rounded-lg border border-background-200/80 bg-background-50 p-3 transition-colors hover:border-primary-300"
              >
                <Link
                  to={`/events/${item.slug}`}
                  className="relative block h-24 w-24 shrink-0 overflow-hidden rounded-md md:h-28 md:w-32"
                  aria-label={item.title}
                >
                  <img
                    src={item.cover}
                    alt={`${item.title} 事件配图`}
                    title={`${item.title} - 每日吃瓜大瓜汇总`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </Link>
                <div className="flex min-w-0 flex-1 flex-col justify-between py-1">
                  <div>
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-900">
                      {item.category}
                    </span>
                    <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950">
                      <Link
                        to={`/events/${item.slug}`}
                        className="transition-colors hover:text-primary-700"
                      >
                        {item.title}
                      </Link>
                    </h3>
                  </div>
                  <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500"></i>
                      {item.heat.toFixed(1)}
                    </span>
                    <span>{item.date}</span>
                  </div>
                </div>
              </article>
            ) : null,
          )}
        </div>
      </div>
    </section>
  );
}